import { Input, Output, OnInit, Component, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  FileSelected,
  AcceptableFileTypes,
  FileUploadDialogData,
  PDFReportInformation,
} from 'src/app/core';

import { FilesService } from 'src/app/feature/services';

@Component({
  selector: 'shared-file-placeholder',
  styleUrls: ['./file-placeholder.component.scss'],
  templateUrl: './file-placeholder.component.html',
})
export class FilePlaceholderComponent implements OnInit {
  @Input('name') name!: string;
  @Input('help') help!: string;
  @Input('urlName') urlName!: string;
  @Input('color') color: ThemePalette;
  @Input('placeholder') placeholder!: string;
  @Input('immediateUpload') immediateUpload: boolean = false;
  @Input('fileType') fileType: AcceptableFileTypes[] = ['application/pdf'];
  @Input('layouts') layouts!: number[];
  @Input('isImage') isImage!: boolean;
  @Input('selectable') selectable!: boolean;
  @Input('acceptableFormats') acceptableFormats!: string[];
  @Input('noPlaceholder') noPlaceholder!: boolean;
  @Input('uploadButtonTitle') uploadBtnTitle?: string;
  @Output() checkedChange = new EventEmitter<boolean>();
  @Input() checked!: boolean;

  @Output('remove') removeEvent: EventEmitter<FileSelected> =
    new EventEmitter();
  @Output('onFileSelect') onFileSelect: EventEmitter<
    FileSelected | PDFReportInformation
  >;

  public file!: FileSelected | PDFReportInformation;
  public fileSelected: boolean = false;

  public fileCheckboxFormControl = new FormControl(true);

  // Constructors ------------------------->

  constructor(
    private fileService: FilesService,
    private snackBar: MatSnackBar
  ) {
    this.onFileSelect = new EventEmitter();
  }

  ngOnInit(): void {}

  // Public methods ----------------------->

  public sendResultBack() {
    const data: FileUploadDialogData = {
      immediate: this.immediateUpload,
      acceptableTypes: this.fileType,
      urlName: !this.isImage ? this.urlName : 'image.upload',
      apiVersion: 2,
      name: this.name,
    };

    this.fileService
      .openFileUploadDialog<File>({ data })
      .subscribe((file: File) => {
        if (!file) return;

        this.file = { name: this.name, file };
        this.fileSelected = true;

        this.checkFileUpload();
        this.onFileSelect.emit(this.file);
      });
  }

  public checkFileUpload() {
    this.checked = true;
    this.checkedChange.emit(this.checked);
  }

  public toggleCheckBox() {
    if (!this.selectable) {
      return;
    }

    if (!this.fileSelected) {
      this.snackBar.open('ابتدا یک فایل انتخاب کنید', 'باشه', {
        duration: 1000,
      });
      return;
    }

    this.checked = !this.checked;
    this.checkedChange.emit(this.checked);
  }

  public removeSelectedFile() {
    this.removeEvent.emit(this.file as FileSelected);
    this.fileSelected = false;
  }
}
